import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ReportProvider} from '../../providers';
import {CommonService, ReportService, ToasterService} from '../../services';
import {Report} from '../../model';

@Component({
  selector: 'app-view-report-modal',
  templateUrl: './view-report-modal.component.html',
  styleUrl: './view-report-modal.component.scss'
})
export class ViewReportModalComponent implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  images: string[] = [];
  currentReport: Report;
  reportSub: Subscription;
  sending: boolean = false;
  isSend: boolean = false;
  sentSuccess: boolean = false;
  borrowerEmail: string = '';

  constructor(
    public bsModalRef: BsModalRef,
    private reportProvider: ReportProvider,
    private toastr: ToasterService,
    public reportService: ReportService,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description success button click
   */
  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  /**
   * @description cancel button click
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  /** send preview */
  sendPreview(): void{
    this.isSend = true;
    const modalElement = document.getElementsByClassName('modal-lg');
    if (modalElement?.length) {
      modalElement[0].classList.add('modal-md');
      modalElement[0].classList.remove('modal-lg');
    }
  }

  /** send report */
  sendReport(): void{
    this.sending = true;
    this.reportProvider.sendReportPreview(this.currentReport.LATEST.ID).subscribe(response => {
      if (response.success) {
        this.sentSuccess = true;
        setTimeout(() => {
          this.confirm();
        }, 10000);
      }else{
        this.toastr.error(response.error.txt);
      }
      this.sending = false;
    }, err => {
      // Error Handling
      this.sending = false;
    });
  }
}
